import {DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_FOR_EXPORT, DEFAULT_PAGE_SIZE_FOR_FULL_TEXT_SEARCH, Pages} from "./pages";
import { EventFilter, EventFilterParams } from "./event-filter";
import { EventItemType } from "./event-item-type";
import { ListSortOrder } from "./list-sort-order";

export class FindEventsRequest {
  constructor(private pages: Pages, private filter: EventFilter, private order?: ListSortOrder) {
  }

  static createEventsSearchFilter(name: string, type: EventItemType): FindEventsRequest {
    const findRacesRequest: FindEventsRequest = new FindEventsRequest(new Pages(DEFAULT_PAGE_SIZE_FOR_FULL_TEXT_SEARCH, 0),
      {
        name: name,
        dateTo: type === EventItemType.FINISHED ? new Date() : undefined,
        dateFrom: type === EventItemType.UPCOMING ? new Date() : undefined
      });
    return findRacesRequest;
  }

  static createEventRacePagedFilter(page: number, type: EventItemType): FindEventsRequest {
    const findRacesRequest: FindEventsRequest = new FindEventsRequest(new Pages(DEFAULT_PAGE_SIZE, page),
      {
        dateTo: type === EventItemType.FINISHED ? new Date() : undefined,
        dateFrom: type === EventItemType.UPCOMING ? new Date() : undefined
      });
    return findRacesRequest;
  }

  static createEventPageFilter(page: number, params?: EventFilterParams, sortOrder?: ListSortOrder, pageSize?: number): FindEventsRequest {
    const findEventsRequest: FindEventsRequest = new FindEventsRequest(new Pages(pageSize ?? DEFAULT_PAGE_SIZE, page), {...params}, sortOrder);
    return findEventsRequest;
  }

  static createEventPageFilterForExport(page: number, params?: EventFilterParams, sortOrder?: ListSortOrder): FindEventsRequest {
    const findEventsRequest: FindEventsRequest = new FindEventsRequest(new Pages(DEFAULT_PAGE_SIZE_FOR_EXPORT, page), {...params}, sortOrder);
    return findEventsRequest;
  }
}
